function getEnv() {
  if (g.envProd()) {
    return 'prod'
  }

  const hostname = window.location.hostname;

  if (hostname === 'stg-otbp-trnelb.onetapbuy.jp') {
    return 'stg1-1'
  }

  // default stg1-2
  return 'stg1-2'
}

function getAssetManagementAppId() {
  const env = getEnv();

  switch(env) {
    case 'prod':
      return 'm_512cIsRNmu';
    case 'stg1-1':
      // STG1-1 -> STG1
      return 'm_SW49LDBJmi';
    case 'stg1-2':
      // STG1-2 -> STG2-1
      return 'm_J6OSkIRVpj';
  }
}

function getAssetManagementUrl() {
  const env = getEnv();

  switch(env) {
    case 'prod':
      return 'https://jp-4pay-trnelb.paypay-sec.co.jp/invest/redirect';
    case 'stg1-1':
      // STG1-1 -> STG1
      return 'https://stg-4pay-trnelb.paypay-sec.co.jp/invest/redirect';
    case 'stg1-2':
      // STG1-2 -> STG2-1
      return 'https://devstgjp-4pay-trnelb01.onetapbuy.jp/invest/redirect';
  }
}

// Temporarily using asset management config.
// Will be updated to new config later.
function getConfigBaseUrl() {
  const env = getEnv();

  switch(env) {
    case 'prod':
      return 'https://config.mini-app-4pay.devops-app.paypay-sec.co.jp/prod/public/stateless/mini-app/';
    case 'stg1-1':
      return 'https://config.mini-app-4pay-stg1.stg-devops-app.paypay-sec.co.jp/stg1/public/stateless/mini-app/'
    case 'stg1-2':
      return 'https://config.mini-app-4pay-stg2-1.stg-devops-app.onetapbuy.jp/stg2-1/public/stateless/mini-app/'
  }
}

function addAssetsPublicPath(assetPath) {
  if (!process.env.assetBase) {
    return '/' + assetPath; // fallback behavior, mostly for local dev.
  }

  return process.env.assetBase + assetPath;
}

export { getAssetManagementAppId, getAssetManagementUrl, getConfigBaseUrl, addAssetsPublicPath, getEnv }